var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "advisory-opcoes-tabela d-flex flex-column" },
    [
      _vm.carregando
        ? _c(
            "p",
            {
              staticClass: "az-text-secondary az-size-12 mb-0",
              attrs: { "data-test": "advisory-opcoes-carregando" }
            },
            [_vm._v(" " + _vm._s(_vm.textoCarregando) + " ")]
          )
        : _vm.erro
        ? _c(
            "p",
            {
              staticClass:
                "az-text-secondary az-size-12 mb-0 advisory-opcoes-tabela__erro",
              attrs: { "data-test": "advisory-opcoes-erro" }
            },
            [_vm._v(" " + _vm._s(_vm.textoErro) + " ")]
          )
        : _vm.vazio
        ? _c(
            "p",
            {
              staticClass: "az-text-secondary az-size-12 mb-0",
              attrs: { "data-test": "advisory-opcoes-vazio" }
            },
            [_vm._v(" " + _vm._s(_vm.textoVazio) + " ")]
          )
        : _c("BaseTable", {
            attrs: {
              bordered: "",
              "hide-default-footer": "",
              headers: _vm.headers,
              items: _vm.linhas,
              "items-per-page": -1,
              "item-key": "nome",
              "no-data-text": _vm.textoVazio,
              "data-test": "advisory-opcoes-tabela"
            },
            on: { "click:row": _vm.onSelecionar },
            scopedSlots: _vm._u([
              {
                key: "item.nome",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    item
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "advisory-opcoes-tabela__celula advisory-opcoes-tabela__celula--opcao d-flex align-center az-gap-xsmall",
                            class: item.classeLinha
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "az-text-primary az-size-14 font-medium"
                              },
                              [_vm._v(_vm._s(item.rotulo))]
                            ),
                            item.ehRecomendadaLinha
                              ? _c("icon-svg", {
                                  attrs: {
                                    name: _vm.iconeRecomendada,
                                    size: 14,
                                    color: "warning",
                                    "data-test":
                                      "advisory-opcoes-icone-recomendada"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "item.descricao",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    item
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "advisory-opcoes-tabela__celula d-flex flex-column az-gap-xsmall py-2",
                            class: item.classeLinha
                          },
                          [
                            item.nome
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "az-text-primary az-size-12 font-medium advisory-opcoes-tabela__clique",
                                    attrs: {
                                      role: "button",
                                      tabindex: "0",
                                      "data-test":
                                        "advisory-opcoes-titulo-linha"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.alternarExpansao(item)
                                      },
                                      keydown: function($event) {
                                        $event.stopPropagation()
                                        return _vm.onKeydownExpansao(
                                          $event,
                                          item
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(item.nome) + " ")]
                                )
                              : _vm._e(),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "az-text-secondary az-size-12 advisory-opcoes-tabela__clique",
                                class: {
                                  "advisory-opcoes-tabela__clamp":
                                    item.clampAtivoLinha
                                },
                                attrs: {
                                  role: "button",
                                  tabindex: "0",
                                  "data-test": "advisory-opcoes-descricao"
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.alternarExpansao(item)
                                  },
                                  keydown: function($event) {
                                    $event.stopPropagation()
                                    return _vm.onKeydownExpansao($event, item)
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(item.descricaoTexto) + " ")]
                            ),
                            item.ehInviavelLinha
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-center az-gap-xsmall advisory-opcoes-tabela__motivo",
                                    attrs: {
                                      "data-test":
                                        "advisory-opcoes-motivo-inviabilidade"
                                    }
                                  },
                                  [
                                    _c("icon-svg", {
                                      staticClass: "flex-shrink-0",
                                      attrs: {
                                        name: _vm.iconeInviavel,
                                        size: 14,
                                        color: "var(--danger)"
                                      }
                                    }),
                                    _c("BaseStatus", {
                                      attrs: {
                                        text: "",
                                        "preserve-case": "",
                                        content: _vm.textoInviavel,
                                        color: "danger"
                                      }
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "az-text-secondary az-size-12"
                                      },
                                      [_vm._v(_vm._s(item.motivoTexto))]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            item.ehDecididaLinha && !item.ehRecomendadaLinha
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-center az-gap-xsmall",
                                    attrs: {
                                      "data-test":
                                        "advisory-opcoes-selo-decisao-gestor"
                                    }
                                  },
                                  [
                                    _c("icon-svg", {
                                      staticClass: "flex-shrink-0",
                                      attrs: {
                                        name: _vm.iconeDecisaoGestor,
                                        size: 14,
                                        color: "var(--neutral-600)"
                                      }
                                    }),
                                    _c("BaseStatus", {
                                      attrs: {
                                        text: "",
                                        "preserve-case": "",
                                        content: _vm.textoDecisaoGestor,
                                        color: "neutral-600"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "item.impactoEsperado",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    item
                      ? _c(
                          "div",
                          {
                            staticClass: "advisory-opcoes-tabela__celula",
                            class: item.classeLinha
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "advisory-opcoes-tabela__clique",
                                class: {
                                  "advisory-opcoes-tabela__clamp":
                                    item.clampAtivoLinha
                                },
                                attrs: { role: "button", tabindex: "0" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.alternarExpansao(item)
                                  },
                                  keydown: function($event) {
                                    $event.stopPropagation()
                                    return _vm.onKeydownExpansao($event, item)
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(item.impactoTexto) + " ")]
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "item.capitalBrl",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    item
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "advisory-opcoes-tabela__celula d-flex align-center justify-end",
                            class: item.classeLinha
                          },
                          [_vm._v(" " + _vm._s(item.capitalTexto) + " ")]
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "item.pessoas",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    item
                      ? _c(
                          "div",
                          {
                            staticClass: "advisory-opcoes-tabela__celula",
                            class: item.classeLinha
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "advisory-opcoes-tabela__clique",
                                class: {
                                  "advisory-opcoes-tabela__clamp":
                                    item.clampAtivoLinha
                                },
                                attrs: { role: "button", tabindex: "0" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.alternarExpansao(item)
                                  },
                                  keydown: function($event) {
                                    $event.stopPropagation()
                                    return _vm.onKeydownExpansao($event, item)
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(item.pessoasTexto) + " ")]
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "item.prazo",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    item
                      ? _c(
                          "div",
                          {
                            staticClass: "advisory-opcoes-tabela__celula",
                            class: item.classeLinha
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "advisory-opcoes-tabela__clique",
                                class: {
                                  "advisory-opcoes-tabela__clamp":
                                    item.clampAtivoLinha
                                },
                                attrs: { role: "button", tabindex: "0" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.alternarExpansao(item)
                                  },
                                  keydown: function($event) {
                                    $event.stopPropagation()
                                    return _vm.onKeydownExpansao($event, item)
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(item.prazoTexto) + " ")]
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "item.risco",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    item
                      ? _c(
                          "div",
                          {
                            staticClass: "advisory-opcoes-tabela__celula",
                            class: item.classeLinha
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "advisory-opcoes-tabela__clique",
                                class: {
                                  "advisory-opcoes-tabela__clamp":
                                    item.clampAtivoLinha
                                },
                                attrs: { role: "button", tabindex: "0" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.alternarExpansao(item)
                                  },
                                  keydown: function($event) {
                                    $event.stopPropagation()
                                    return _vm.onKeydownExpansao($event, item)
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(item.riscoTexto) + " ")]
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "item.dependencias",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    item
                      ? _c(
                          "div",
                          {
                            staticClass: "advisory-opcoes-tabela__celula",
                            class: item.classeLinha
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "advisory-opcoes-tabela__clique",
                                class: {
                                  "advisory-opcoes-tabela__clamp":
                                    item.clampAtivoLinha
                                },
                                attrs: { role: "button", tabindex: "0" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.alternarExpansao(item)
                                  },
                                  keydown: function($event) {
                                    $event.stopPropagation()
                                    return _vm.onKeydownExpansao($event, item)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(item.dependenciasTexto) + " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }